import { useState } from 'react'
import { PhotoIcon } from '@heroicons/react/24/outline';
import { Button } from "components";

function PORes() {

    const [proofOfResidence, setProofOfResidence] = useState("");
    const [processing, setProcessing] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        setProcessing(true);

        setTimeout(() => {
            setProcessing(false);
        }, 3000);
    }

    return (
		<form className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full" onSubmit={handleSubmit}>

            <div className="col-span-full">
				<label htmlFor="cover-photo" className="form-label">
					Proof of residence (Upload either a utility bill, bank statement, or a letter from a government agency)
				</label>
				<div className="mt-2 flex justify-center rounded-lg border border-dashed border-gray-900/25 dark:border-white px-6 py-10">
					<div className="text-center">
						<PhotoIcon className="mx-auto h-12 w-12 text-gray-300" aria-hidden="true" />
						<div className="mt-4 flex text-sm leading-6 text-gray-600">
							<label htmlFor="file-upload" className="relative cursor-pointer rounded-md font-semibold text-slate-700 dark:text-text-dark hover:text-indigo-500">
								<span>Upload a file</span>
								<input
									id="file-upload"
									name="file-upload"
									type="file"
									className="sr-only"
                                    value={proofOfResidence}
                                    onChange={(e) => setProofOfResidence(e.target.value)}
								/>
							</label>
							<p className="pl-1">or drag and drop</p>
						</div>
						<p className="text-xs leading-5 text-gray-600">
							PNG, JPG, GIF up to 10MB
						</p>
					</div>
				</div>
			</div>

            <div className='col-span-1 mt-6'>
                <Button 
                    btnText={"Upload"}
                    btnType={"submit"}
                    btnClasses={"form-button"}
                    processing={processing}
                />
            </div>

        </form>
    )
}

export default PORes